import { SiteContentScopes } from "@finbackoffice/enums";
import { FC, useContext, useMemo } from "react";
import { BannersContext, useLayoutCasinoConfig } from "@finbackoffice/site-core";
import BannersSlider from "components/base/banners-slider/BannersSlider";
import TopWinners from "components/layout/casino/live-casino/compact/top-winners/TopWinners";
import styles from "./slots-compact-header.module.sass";

const SlotsCompactHeader: FC = () => {
    const { showWinners } = useLayoutCasinoConfig("slots");
    const { banners } = useContext(BannersContext);

    const mainBannersMemo = useMemo(
        () => banners.filter((banner) => banner.tags.includes(SiteContentScopes.MainBanner)),
        [banners],
    );

    const topBannerMemo = useMemo(
        () => banners.filter((banner) => banner.tags.includes(SiteContentScopes.TopBanner)),
        [banners],
    );

    const bottomBannerMemo = useMemo(
        () => banners.filter((banner) => banner.tags.includes(SiteContentScopes.BottomBanner)),
        [banners],
    );

    const hasBottomBanner = Boolean(bottomBannerMemo.length);

    const renderBanners = (
        <>
            <BannersSlider
                banners={mainBannersMemo}
                wrapperClassName={styles.casinoBanner}
                imgProps={{
                    width: 870,
                    height: 224,
                }}
                showOverlay
            />
            {showWinners ? (
                <TopWinners
                    config={{
                        id: "",
                        sport: false,
                        livecasino: true,
                        slots: true,
                        casinoGameId: "",
                    }}
                />
            ) : (
                <div className={styles.bannerLinks}>
                    <BannersSlider
                        banners={topBannerMemo}
                        wrapperClassName={styles.bannerLink}
                        imgProps={{
                            width: 332,
                            height: hasBottomBanner ? 110 : 224,
                        }}
                    />
                    {hasBottomBanner && (
                        <BannersSlider
                            banners={bottomBannerMemo}
                            wrapperClassName={styles.bannerLink}
                            imgProps={{
                                width: 332,
                                height: 110,
                            }}
                        />
                    )}
                </div>
            )}
        </>
    );

    return <div className={styles.casinoHeader}>{renderBanners}</div>;
};

export default SlotsCompactHeader;
